import "./PageLayout.Styles.scss";
interface PageLayout_TwoCol_Props {
    col1: JSX.Element;
    col2: JSX.Element;
    col1NoPadding?: boolean;
    col2NoPadding?: boolean;
}
export function PageLayout_TwoCol_Narrow_Wide(props:PageLayout_TwoCol_Props) {
  return (
    <div className="PageLayout TwoCol_NarrowWide">
        <div className={`column col1 ${props.col1NoPadding ? 'noPadding' : ''}`}>{props.col1}</div>
        <div className={`column col2 ${props.col2NoPadding ? 'noPadding' : ''}`}>{props.col2}</div>
    </div>
  );
}


interface Layout_SidebarProps {
  sidebar: JSX.Element;
  content: JSX.Element;
  sidebarNoPadding?: boolean;
  contentNoPadding?: boolean;
  className?: string;
}
export function LayoutWithSidebar(props:Layout_SidebarProps) {

  return (
    <div className={"LayoutWithSidebar absolute inset-0 " + props.className ? props.className : ""}>
        <div className="absolute left-0 top-0 bottom-0 w-60 bg-white border-r border-[#C3C3C3] pb-20 overflow-auto z-0">{props.sidebar}</div>
        <div className={`absolute left-60 top-0 bottom-0 right-0 overflow-y-auto z-50`}>{props.content}</div>
    </div>
  );
}

export function LayoutWithWideSidebar(props:Layout_SidebarProps) {  
  return (
    <div className="LayoutWithSidebar absolute inset-0">
        <div className="absolute left-0 top-0 bottom-0 w-[300px] bg-white border-r border-[#C3C3C3] pt-0 pb-20 overflow-y-auto">{props.sidebar}</div>
        <div className={`absolute left-[300px] top-0 bottom-0 right-0 overflow-y-auto z-50`}>{props.content}</div>
    </div>
  );
}

export function LayoutHeader(props: {children: JSX.Element | JSX.Element[], noPadding?: boolean, className?: string}) {
  return (
    <div className={props.className ? "LayoutHeader " + props.className : "LayoutHeader" } style={props.noPadding? { padding:"0"} :{}}>
        {props.children}
    </div>
  );
}